// App MY FINANCE — budget et finances familiales de la suite MoP.
// Deux points de vue complémentaires :
//   • MOIS      — prévu vs réalisé : ce qui devait arriver a-t-il eu lieu ?
//                 écarts, manquants, imprévus (cf. CONCEPTION-FINANCE.md).
//   • BUDGETS   — les enveloppes et leurs opérations (parts, qui doit à qui),
//                 + import de relevés bancaires.
// À venir : projection des mois à venir, crédits, synthèses/graphiques.
import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import {
  CoreProviders, CoquilleApp, EcranFT, EcranProfil,
  useAuth, useT, useMenuOngletActif, FonctionsProvider, FONCTIONS_CORE,
} from '@mop/core';
import {
  EcranFinances, EcranMois, EcranComptes, EcranProjection, SectionCategories, FONCTIONS_FINANCE,
} from '@mop/feature-finance';

const APP = { id: 'mop-my-finance', nom: 'My Finance', version: '0.6.71.18', scheme: 'mopmyfinance' };

// L'app COMPOSE les catalogues : socle Core + fonctions du module finance
// (c'est ce catalogue que MoP Admin rattache aux forfaits).
const CATALOGUE = [...FONCTIONS_CORE, ...FONCTIONS_FINANCE];

const Profil = () => {
  const { estIVV } = useAuth();
  const t = useT();
  useMenuOngletActif('Profil', [
    { label: t('ft.ivvFaitsTechniques'), icone: '🐞', navigateVers: 'IVV' },
  ], estIVV);
  // « Gestion de l'application » (Cedric, 15/08) : la gestion des categories
  // vit dans le Profil, comme toute configuration.
  return <EcranProfil sections={[
    { cle: 'categories', titre: t('finances.gestionCategories'), emoji: '🏷️',
      rendu: <SectionCategories /> },
  ]} />;
};

const Racine = () => {
  const t = useT();
  const onglets = [
    // ORDRE (Cédric, 14/08) : Comptes → Budget → Suivi. C'est celui du
    // raisonnement, pas de l'implémentation : on part de ce qui est CONSTATÉ
    // (le relevé), on le confronte à ce qui était ESTIMÉ (les enveloppes), et
    // le Suivi montre l'écart. Il vient donc en dernier — il ne se lit qu'une
    // fois les deux autres compris.
    { cle: 'Comptes',  label: t('finances.comptes'),    icone: '🏦', composant: EcranComptes },
    // Clé DÉDIÉE, et non `famille.t.finances` : cette dernière est lue par la
    // tuile du hub Famille de My Calendar (`EcranFamille.js:68`, clé construite
    // dynamiquement). La changer renommerait un écran d'une autre app.
    { cle: 'Budgets',  label: t('finances.ongletBudget'), icone: '💶', composant: EcranFinances },
    // « Mois » ne disait que la période, pas la fonction : cet écran CONFRONTE
    // l'estimé au réel. D'où « Suivi », et 📊 plutôt que 📅.
    // La clé garde son nom (`vueMois`) : elle décrit la vue mensuelle, et la
    // renommer toucherait un catalogue que les cinq apps partagent.
    { cle: 'Mois',     label: t('finances.vueMois'),      icone: '📊', composant: EcranMois },
    // Une fois le constaté et l'estimé compris, la Projection répond à « où
    // en sera ma trésorerie dans N mois ? » — même icône/libellé que la
    // fonction déclarée au catalogue (`fonctions.js:11`).
    { cle: 'Projection', label: t('finances.ongletProjection'), icone: '📈', composant: EcranProjection },
    { cle: 'Profil',   label: t('nav.profil'),         icone: '👤', composant: Profil },
    { cle: 'IVV',      label: t('nav.ivv'),            icone: '🐞', composant: EcranFT, masque: true },
  ];
  return <CoquilleApp onglets={onglets} avecPub />;
};

export default function App() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <CoreProviders app={APP} theme="auto">
        <FonctionsProvider catalogue={CATALOGUE}>
          <StatusBar style="auto" />
          <Racine />
        </FonctionsProvider>
      </CoreProviders>
    </GestureHandlerRootView>
  );
}
